// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"videoModal_wrapper__AzW86","loaded":"videoModal_loaded__ZehkO","videoLink":"videoModal_videoLink__tSF9U"};